// extracted by mini-css-extract-plugin
module.exports = {"root":"SettingsDeletedPatients_root__1xqEV"};